(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product"]) return;
  try {
    
if (!customElements.get('bh-waterproof-gallery')) {
  customElements.define('bh-waterproof-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const root = this.closest('[data-product]');
      const colourPosition = this.dataset.colourPos;
      const items = Array.from(this.querySelectorAll('[data-media-colour]'));
      let colour = this.dataset.colour;
      const show = (next) => {
        if (!next || next === colour) return;
        colour = next;
        this.dataset.colour = next;
        items.forEach((item) => {
          item.hidden = item.dataset.mediaColour !== next;
          if (item.hidden) item.querySelectorAll('video').forEach((video) => video.pause());
        });
      };
      this.variantListener = (event) => show(event.detail?.['option' + colourPosition]);
      root?.addEventListener('bh:variant', this.variantListener);
      this.productRoot = root;
      const dialog = this.querySelector('dialog');
      this.addEventListener('click', (event) => {
        const photo = event.target.closest('[data-full]');
        if (!photo || !dialog) return;
        const image = dialog.querySelector('.bh-wpg__zoom-image');
        image.src = photo.dataset.full;
        image.alt = photo.querySelector('img')?.alt || '';
        dialog.showModal();
      });
      const start = () => requestAnimationFrame(() => {
        if (this.hasAttribute('data-start-model')) {
          const button = root?.querySelector('[data-opt-group="' + colourPosition + '"] [data-opt-value="Bronze"]');
          button?.click();
        }
      });
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
      else start();
    }
    disconnectedCallback() {
      this.productRoot?.removeEventListener('bh:variant', this.variantListener);
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
